import { Badge, Col, Container, Nav, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import { HeaderBuilder } from '../components';

export interface TabType {
  title: string;
  path: string;
  tabLink?: string;
  label?: number | string;
  tooltip?: string;
}

export interface HeaderProps {
  title?: string;
  subtitle?: string;
  tabs?: TabType[];
  total?: number;
  headerButton?: JSX.Element;
  isDetailPage?: boolean;
}

const BuildTabs = ({ tabs, total, title }: { tabs?: TabType[]; total?: number; title?: string }) => {
  if (tabs?.length) {
    return (
      <>
        <HeaderBuilder.Tabs className="nav-overflow">
          {tabs.map(tab => (
            <Nav.Item key={tab.path} style={{ minWidth: 120 }}>
              <Nav.Link as={NavLink} to={`${tab.tabLink}`} end className="text-nowrap" role="button">
                {tab.title}{' '}
                <Badge bg="secondary-soft" className="rounded-pill">
                  {total}
                </Badge>
              </Nav.Link>
            </Nav.Item>
          ))}
        </HeaderBuilder.Tabs>
      </>
    );
  }
  return (
    <HeaderBuilder.Tabs className="nav-overflow">
      <Nav.Item style={{ minWidth: 120 }}>
        <Nav.Link className="text-nowrap" role="button" active>
          {title ?? ''}
          <Badge bg="secondary-soft" className="rounded-pill">
            {total}
          </Badge>
        </Nav.Link>
      </Nav.Item>
    </HeaderBuilder.Tabs>
  );
};

const Header = ({ title, headerButton, tabs, total, isDetailPage /* subtitle /* tabs */ }: HeaderProps) => {
  return (
    <HeaderBuilder>
      <Container fluid>
        <HeaderBuilder.Body>
          <Row className="row align-items-end">
            <Col>
              <HeaderBuilder.Pretitle>Overview</HeaderBuilder.Pretitle>
              <HeaderBuilder.Title>{title}</HeaderBuilder.Title>
            </Col>
            <Col xs="auto">{headerButton}</Col>
          </Row>
          {title !== 'Dashboard' && !isDetailPage && (
            <Row className="align-items-center">
              <Col>
                <BuildTabs tabs={tabs} total={total} title={title} />
              </Col>
            </Row>
          )}
        </HeaderBuilder.Body>
      </Container>
    </HeaderBuilder>
  );
};

export default Header;
